exports.default = {
  'sms_login': '短信登錄',
  'pwd_login': '密碼登錄',
  'please_enter_your_mobile_number_or_email': '請輸入手機號或郵箱',
  'please_enter_your_pwd': '請輸入密碼',
  'forgot_password': '忘記密碼？',
  'no_account': '還沒有賬號？',
  'register_new_account': '註冊新賬號',
  'login_failed': '登錄失敗',
  'login_success': '登錄成功',
  'verification_title': '請輸入驗證碼',
  'code_sent_to_email': '驗證碼已經發送至您的郵箱',
  'code_sent_to_phone': '驗證碼已經發送至您的手機',
  'verification_sent': '驗證碼已經發送至您的郵箱或手機',
  'enter_password': '請輸入您的密碼',
  'enter_account_password': '請輸入您賬號的登錄密碼',
  'verification_failed': '驗證失敗',
  'verification_success': '驗證成功',
  'not_received_code': '沒有收到驗證碼? 稍後重發 ( {time} )',
  'resend_code': '沒有收到驗證碼?點擊重發',
  'continue': '繼續',
  'back': '返回',
  'code_sent': '驗證碼已發送，請查收',
  'sms_retrieval_password': '手機找回密碼',
  'mail_retrieval_password': '郵箱找回密碼',
  'enter_mobile_number': '請輸入手機號',
  'verification_code_input': '請輸入驗證碼',
  'get_verification_code': '獲取驗證碼',
  'please_set_the_password': '請設置密碼',
  'enter_the_password_again': '再次輸入密碼',
  'reading_consent': '閱讀並同意',
  'user_agreement': '《AgentStore服務協議及隱私條款》',
  'forget_reset': '重置',
  'existing_account_number': '已有賬號？',
  'log_in_now': '立即登錄',
  'enter_mail': '請輸入郵箱',
  'please_enter_your_mobile_number': '請輸入手機號碼',
  'please_enter_the_verification_code': '請輸入驗證碼',
  'please_confirm_the_password_again': '請再次確認密碼',
  'please_keep_the_same_password_twice': '兩次輸入密碼保持一致',
  'please_enter_your_email': '請輸入郵箱',
  'input_the_phone_number_correctly': '請正確輸入手機號碼',
  'password_check_error': '密碼必須包含8-16個字符，至少包含大小寫字母、數字',
  'email_check_error': '請輸入正確的郵箱地址',
  'login_title': '登錄Paiteams',
  'login_title_prefix': '登錄',
  'welcome_text': '歡迎回來！',
  'google_login': '使用Google賬號登錄',
  'phone_login': '手機登錄',
  'email_login': '郵箱登錄',
  'password_login': '密碼登錄',
  'or': '或者',
  'email_address': '郵箱地址',
  'email_placeholder': '請輸入您的郵箱地址',
  'phone_number': '手機號碼',
  'phone_placeholder': '請輸入您的手機號碼',
  'username_label': '手機號/郵箱',
  'username_placeholder': '請輸入您的賬號',
  'password_title': '請輸入密碼',
  'password_desc': '請輸入您賬號的登錄密碼',
  'login_button': '登錄',
  'password_error': '密碼錯誤',
  'mobile_registration': '手機註冊',
  'mailbox_registration': '郵箱註冊',
  'register': '註冊',
  'authentication_failed': '認證失敗',
  'invite_you': '邀請你使用 PAITEAMS',
  'welcome_use': '歡迎使用 PAITEAMS',
  'register_to_get': '註冊即可領 ',
  'new_user_points': '新用戶積分',
  'brand_logo_alt': 'PAITEAMS 標誌',
  'back_home': '返回首頁',
  'hero_title_prefix': '釋放你的',
  'hero_title_highlight': '無限潛能',
  'hero_phrase_ready': '你的 AI 專家團隊已準備就緒',
  'hero_phrase_workflows': '讓複雜工作流程更高效',
  'hero_phrase_deliver': '設計、開發、交付，一氣呵成',
  'feature_automation': 'AI 驅動的工作流程自動化',
  'feature_security': '企業級安全保障',
  'feature_collaboration': '無縫團隊協作',
  'terms': '服務條款',
  'agreement_and': '與',
  'agreement_suffix': '。',
  'login_error': '登錄出錯，請稍後重試。',
  'code_sent_to_contact': '驗證碼已發送至 {contact}',
  'edit_contact': '修改登錄賬號',
  'verification_digit': '第 {index} 位驗證碼',
  'verification_success_redirecting': '驗證成功，正在跳轉…',
  'verify_and_login': '驗證並登錄',
  'please_enter_complete_code': '請輸入完整的 6 位驗證碼。',
  'sending_code': '正在發送驗證碼…',
  'incorrect_verification_code': '驗證碼不正確，請重試。',
  'copyright': '© 2025 PAITEAMS. 保留所有權利。',
  'dialog_kicker': 'PAITEAMS 通行證',
  'dialog_title': '登入，繼續你的創作',
  'dialog_subtitle': '使用驗證碼快速登入；新帳號將自動完成註冊。',
  'dialog_close': '關閉登入彈窗',
  'login_methods': '登入方式',
  'phone_code_login': '手機號登入',
  'email_code_login': '電子郵件登入',
  'verification_code_label': '驗證碼',
  'phone_code_placeholder': '請輸入6位簡訊驗證碼',
  'email_code_placeholder': '請輸入6位電子郵件驗證碼',
  'send_code': '取得驗證碼',
  'resend_after': '{time}秒後重發',
  'send_code_failed': '驗證碼發送失敗，請稍後重試',
  'verification_code_invalid': '請輸入6位驗證碼',
  'agreement_prefix': '我已閱讀並同意',
  'terms_of_service': '使用者服務協議',
  'privacy_policy': '隱私政策',
  'agreement_required': '請先閱讀並同意相關協議',
  'other_login_methods': '其他方式登入',
  'login_in_progress': '正在登入',
  'google_redirecting': '正在前往 Google',
  'google_redirect_failed': '暫時無法跳轉至 Google 登入',
  'wechat_login': '微信登入',
  'wechat_login_pending': '微信登入串接中',
  'invite_invalid': '邀請碼無效或已過期，仍可繼續登入',
  'visual_eyebrow': 'YOUR AI CREW',
  'visual_title': '把靈感，變成真正的作品。',
  'visual_description': '登入後繼續對話、儲存專案，並隨時調用你的專屬 AI 團隊。',
  'visual_feature': '專案記錄與團隊空間安全同步',
  'reason_auth_required': '登入後即可繼續目前操作',
  'reason_chat': '登入後即可發送訊息並儲存對話',
  'reason_knowledge': '登入後即可存取專案與知識庫',
  'reason_assets': '登入後即可管理資產',
  'reason_account': '登入後即可查看和管理你的帳號',
  'reason_subscription': '登入後即可查看訂閱與方案',
  'reason_invite': '登入後即可查看邀請獎勵',
  'reason_image_recents': '登入後即可查看最近創作',
  'reason_upload': '登入後即可上傳檔案和參考圖',
  'reason_image_generation': '登入後即可生成並儲存圖片',
  'reason_web_generation': '登入後即可生成並儲存網頁專案',
  'reason_payment_result': '登入後即可查看付款結果',
  'mobile_pc_guide_title': '請使用電腦\n體驗 PAITEAMS',
  'mobile_pc_guide_invite_title': '積分已發放\n請使用電腦存取\n體驗 PAITEAMS'
}
